import React, {useEffect, useState} from "react";
import {Close, Save} from "@mui/icons-material";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Typography
} from "@mui/material";
import IconButton from "@mui/material/IconButton";


export default function StyledModal({
                                        children,
                                        send,
                                        dismiss,
                                        title,
                                        description,
                                        isOpen = false,
                                        actionLabel = 'Dodaj',
                                        actionColor = 'success',
                                        fullWidth = false,
                                        maxWidth = 'sm',
                                        additionalActions = '',
                                        successIcon = <Save color="light" size={'1rem'}/>
                                    }) {
    const closeCss = {
        position: 'absolute',
        right: 8,
        top: 8
    };
    const [sending, setSending] = useState(false);

    useEffect(() => {
        setSending(false);
    }, [isOpen]);

    return (<Dialog open={isOpen} onClose={dismiss} fullWidth={fullWidth} maxWidth={maxWidth}>
        <IconButton variant={'text'} onClick={dismiss} sx={closeCss}><Close/></IconButton>
        <DialogTitle variant={'h5'} fontWeight={'light'}>
            {title}
        </DialogTitle>
        {description !== undefined && <Typography variant={'p'} fontSize={'small'} fontWeight={'regular'}
                                                    sx={{padding: '0 16px'}}>{description}</Typography>}
        <DialogContent>
            <Stack spacing={2}>
            {children}
            </Stack>
        </DialogContent>
        <DialogActions sx={{display: 'flex', justifyContent: 'space-between'}}>
            <Button onClick={dismiss} color={'gray'} variant={'contained'}>Anuluj</Button>
            {additionalActions}
            <Button startIcon={sending === true ? <CircularProgress color="light" size={'1rem'}/> : successIcon} onClick={() => {setSending(true); send();}} color={actionColor} disabled={sending} variant={'contained'}>{actionLabel}</Button>
        </DialogActions>
    </Dialog>);
}